import React from "react";
import * as Sentry from "@sentry/react";
import Fallback from "./Fallback";
import { Outlet } from "react-router-dom";

const MyErrorBoundary = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={Fallback}>
      {!!children && children}
      {!children && <Outlet />}
    </Sentry.ErrorBoundary>
  );
};

export default MyErrorBoundary;
